export default class PipelineStore {
  constructor() {
    this.state = {};

    this.state.pipeline = {};
  }

  storePipeline(pipeline = {}) {
    this.state.pipeline = pipeline;
  }
}



// WEBPACK FOOTER //
// ./pipelines/stores/pipeline_store.js